import {useFormContext} from "react-hook-form";

import {ColumnSelector} from "@/components/columnSelector/ColumnSelector.tsx";
import {ColumnOption} from "@/components/columnSelector/ColumnSelector.types.ts";
import {FormSubtext} from "@/components/formSubtext/FormSubtext.tsx";
import {getFormError} from "@/lib/form/form.utils.ts";

interface ColumnSelectorFieldProps {
  name: string;
  availableColumns: ColumnOption[];
}

export const ColumnSelectorField = ({name, availableColumns}: ColumnSelectorFieldProps) => {
  const {
    watch,
    setValue,
    formState: {errors},
  } = useFormContext();
  const selectedColumns: ColumnOption[] = watch(name) ?? [];
  const fieldError = getFormError(name, errors);

  const onChange = (columns: ColumnOption[]) => {
    setValue(name, columns, {shouldDirty: true, shouldValidate: true});
  };

  return (
    <div>
      <ColumnSelector
        availableColumns={availableColumns}
        selectedColumns={selectedColumns}
        onChange={onChange}
        aria-invalid={!!fieldError}
      />
      <FormSubtext error={fieldError?.toString()} />
    </div>
  );
};
